<template>
    <div class="ui segment">
        <h4>{{ user.first_name }} {{ user.last_name }}</h4>
    </div>
</template>

<script>
export default {
  name: 'me-overview',

  computed: {
    user() {
      return this.$store.state.auth.user;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/user/MeOverview.vue